(function () {
  'use strict';

  function initComparePass() {
    const sections = document.querySelectorAll('.compare-pass');

    sections.forEach(function (section) {
      const dropdown = section.querySelector('.compare-pass__dropdown');
      if (!dropdown) return;

      const selectedLabel = dropdown.querySelector('.compare-pass__dropdown-selected');
      const list = section.querySelector('.compare-pass__dropdown-list');
      const options = list ? list.querySelectorAll('.compare-pass__dropdown-option') : [];
      const panels = section.querySelectorAll('.compare-pass__country-panel');

      function forceOptionStyles(opt, color) {
        opt.style.setProperty('color', color || '#000000', 'important');
        opt.style.setProperty('background-color', '#ffffff', 'important');
        opt.style.setProperty('display', 'block', 'important');
        opt.style.setProperty('line-height', '1.4', 'important');
        opt.style.setProperty('font-size', '1.4rem', 'important');
        opt.style.setProperty('padding', '10px 12px', 'important');
        opt.style.setProperty('visibility', 'visible', 'important');
        opt.style.setProperty('opacity', '1', 'important');
      }

      // Force styles on init
      if (list) {
        list.style.setProperty('background-color', '#ffffff', 'important');
      }
      options.forEach(function (opt) {
        forceOptionStyles(opt, '#000000');
      });

      function closeDropdown() {
        dropdown.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
        if (list) list.classList.remove('is-open');
      }

      function openDropdown() {
        dropdown.setAttribute('aria-expanded', 'true');
        dropdown.classList.add('is-open');
        if (list) list.classList.add('is-open');
        // Re-force styles on open in case theme re-renders
        options.forEach(function (opt) {
          forceOptionStyles(opt, opt.classList.contains('is-selected') ? '#0099cc' : '#000000');
        });
      }

      function selectOption(value, label) {
        if (selectedLabel) {
          selectedLabel.textContent = label;
          selectedLabel.style.setProperty('color', '#000000', 'important');
        }
        dropdown.classList.add('has-value');

        options.forEach(function (opt) {
          if (opt.dataset.value === value) {
            opt.classList.add('is-selected');
            forceOptionStyles(opt, '#0099cc');
          } else {
            opt.classList.remove('is-selected');
            forceOptionStyles(opt, '#000000');
          }
        });

        panels.forEach(function (panel) {
          panel.hidden = true;
        });

        if (value) {
          const target = section.querySelector('[data-country-id="' + value + '"]');
          if (target) target.hidden = false;
        }

        closeDropdown();
      }

      dropdown.addEventListener('click', function () {
        if (dropdown.classList.contains('is-open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });

      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (dropdown.classList.contains('is-open')) {
            closeDropdown();
          } else {
            openDropdown();
          }
        }
        if (e.key === 'Escape') closeDropdown();
      });

      options.forEach(function (opt) {
opt.addEventListener('mouseover', function () {
  opt.style.setProperty('background-color', '#0099cc', 'important');
  opt.style.setProperty('color', '#ffffff', 'important');
  var inner = opt.querySelector('.country-selector');
  if (inner) inner.style.setProperty('color', '#ffffff', 'important');
});
opt.addEventListener('mouseout', function () {
  var isSelected = opt.classList.contains('is-selected');
  var restoreColor = isSelected ? '#0099cc' : '#000000';
  opt.style.setProperty('background-color', '#ffffff', 'important');
  opt.style.setProperty('color', restoreColor, 'important');
  var inner = opt.querySelector('.country-selector');
  if (inner) inner.style.setProperty('color', restoreColor, 'important');
});

        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          selectOption(opt.dataset.value, opt.textContent.trim());
        });

        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectOption(opt.dataset.value, opt.textContent.trim());
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!section.contains(e.target)) {
          closeDropdown();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComparePass);
  } else {
    initComparePass();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.compare-pass')) {
      initComparePass();
    }
  });
})();